import { render, staticRenderFns } from "./index.vue?vue&type=template&id=628b54d6&scoped=true&"
import script from "./nodes-table.js?vue&type=script&lang=js&"
export * from "./nodes-table.js?vue&type=script&lang=js&"
import style0 from "./nodes-table.css?vue&type=style&index=0&id=628b54d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b54d6",
  null
  
)

export default component.exports